import { Injectable } from '@angular/core';
import { IIdName, IMap } from '@nimbus-library/features/shared/models/interfaces';

export const DEFAULT_AUDIO_FILE = 'bell1.mp3';

@Injectable({ providedIn: 'root' })
export class PredefinedAudioService {
  private audioMap: IMap<HTMLAudioElement> = {};

  public getAudioFiles(): IIdName[] {
    const audioFilesAvailable = ['alarm1.mp3', 'alarm2.mp3', 'bell1.mp3', 'bell2.mp3', 'gong1.mp3', 'siren1.mp3'];
    return audioFilesAvailable.map((x) => ({ id: x, name: x.replace('.mp3', '') }));
  }

  public getUrl(audioFile: string): string {
    return `audio/${audioFile}`;
  }

  public playAudio(audioType: string, audioFile: string, playConstantly: boolean = false): void {
    // If audio is already playing, do not start it again
    const existingAudio = this.audioMap[audioType];
    if (existingAudio) {
      return;
    }

    const audio = this.createAudio(audioType, audioFile, playConstantly);
    audio.play().catch((error) => {
      if (error?.name !== 'NotAllowedError') {
        console.error(`Audio playback failed ${error}`);
      }
      this.stopAudio(audioType);
    });
  }

  public stopAudio(audioType: string): void {
    const audio = this.audioMap[audioType];
    if (!audio) {
      return;
    }
    delete this.audioMap[audioType];
    audio.pause();
    audio.remove();
  }

  private createAudio(audioType: string, audioFile: string, playConstantly: boolean): HTMLAudioElement {
    const audio = new Audio();

    audio.preload = 'none';
    audio.src = this.getUrl(audioFile);
    this.audioMap[audioType] = audio;
    const onFinished = (): void => {
      if (playConstantly) {
        audio.play();
      } else {
        this.stopAudio(audioType);
      }
    };
    audio.onended = onFinished;
    audio.onerror = onFinished;
    return audio;
  }
}
